import { api } from "../services/axios";

const UploadThirdPartyAPI = async (file: FormData) => {
    try {
        debugger
        var result = await api.post(`/ThirdPartyServices/UploadExcel`, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        var response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    UploadThirdPartyAPI
}